import { Col, Form, Row } from "react-bootstrap";
import FormTextField from "@components/Forms/FormTextField";
import { MultiSelectAutocomplete } from "@components/FormsV2/MultiSelectAutoComplete";
import ControlledDropDownV2 from "@components/Forms/ControlledDropDownV2";
import MarkdownTextAreaV2 from "@components/FormsV2/MarkdownTextAreaV2";
import { BlueprintFormState } from "../types";
import { TagOption } from "../../Show/api/useListTagsForAccount";
import { RateTableOption } from "../api/useListRateTables";
import { PaymentTermOption } from "../api/useListPaymentTerms";
import "./style.css";

interface BlueprintGeneralFieldsProps {
  form: BlueprintFormState;
  setForm: React.Dispatch<React.SetStateAction<BlueprintFormState>>;
  tagOptions: TagOption[];
  rateTableOptions: RateTableOption[];
  paymentTermOptions: PaymentTermOption[];
  readOnly?: boolean;
}

const BlueprintGeneralFields = ({
  form,
  setForm,
  tagOptions,
  rateTableOptions,
  paymentTermOptions,
  readOnly,
}: BlueprintGeneralFieldsProps) => {
  const set = (field: keyof BlueprintFormState) => (value: any) =>
    setForm((prev) => ({ ...prev, [field]: value }));

  return (
    <div className="blueprintGeneralFields">
      <Row>
        <Col md={6}>
          <FormTextField
            id="blueprintName"
            label="* Blueprint Name"
            value={form.name}
            placeholder="Enter blueprint name"
            onChange={(e) => set("name")(e.target.value)}
            required={true}
            readOnly={!!readOnly}
          />
        </Col>
        <Col md={6}>
          <MultiSelectAutocomplete
            label="Tags"
            id="blueprintTags"
            options={tagOptions}
            value={form.tags}
            isDisabled={readOnly}
            onChange={(selected) => set("tags")(selected || [])}
          />
        </Col>
      </Row>
      <Row className="blueprintGeneralRow" style={{ marginBottom: "20px" }}>
        <Col md={6}>
          <ControlledDropDownV2
            label="Rate Table"
            value={form.rateTable}
            required={false}
            readOnly={!!readOnly}
            disabled={!!readOnly}
            onChange={(e) => set("rateTable")(e.target.value)}
            options={rateTableOptions.map((rt) => (
              <option key={rt.value} value={rt.value}>
                {rt.label}
              </option>
            ))}
          />
        </Col>
        <Col md={6}>
          <ControlledDropDownV2
            label="Payment Term"
            value={form.paymentTerm}
            required={false}
            readOnly={!!readOnly}
            disabled={!!readOnly}
            onChange={(e) => set("paymentTerm")(e.target.value)}
            options={paymentTermOptions.map((pt) => (
              <option key={pt.value} value={pt.value}>
                {pt.label}
              </option>
            ))}
          />
        </Col>
      </Row>
      <Row className="blueprintGeneralRow">
        <Col md={12}>
          <Form.Label className="blueprintFieldLabel">
            Executive Summary
          </Form.Label>
          <MarkdownTextAreaV2
            value={form.executiveSummary}
            placeholder="Enter executive summary..."
            disabled={readOnly}
            onChange={set("executiveSummary")}
          />
        </Col>
      </Row>
      <Row className="blueprintGeneralRow">
        <Col md={12}>
          <Form.Label className="blueprintFieldLabel">
            Solution Summary
          </Form.Label>
          <MarkdownTextAreaV2
            value={form.solutionSummary}
            placeholder="Enter solution summary..."
            disabled={readOnly}
            onChange={set("solutionSummary")}
          />
        </Col>
      </Row>
    </div>
  );
};

export default BlueprintGeneralFields;
